import React, { useState,useEffect } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate,Link } from "react-router-dom";
import { isValidEmail } from '../../component/common';
import { Eye, EyeOff } from "lucide-react";
import Swal from 'sweetalert2'
import { useGlobalContext } from "./../../component/GlobalContext";
import { MemberShipCardStructure } from "../../component/ReusableComponents";

function MemberProfile() {
    const navigate = useNavigate();
    const [categoriesList, setCategoriesList] = useState([]);
    const access_token = localStorage.getItem('access_token');
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const [urlError, setUrlError] = useState("");
    const [pagination, setPagination] = useState({ page: '1', limit: '100' });
    const [fullName, setFullName] = useState("");

    const [formData, setFormData] = useState({
        first_name: "",
        last_name:"",
        email: "",
        contact_no: "",

      });
    useEffect(() => {
        loadCategories();
        loadvendor();
    }, []);
    
    const loadvendor = async () => {
        
        const config = {
            headers: { 'Content-Type': 'application/json', 'token': access_token },
        };
        HTTP.get("user/me", config, config)
            .then((response) => {
                if (response.status === 200) {
                    setFullName(`${response.data.first_name} ${response.data.last_name}`)
                    // console.log(response.data.business_name)
                    setFormData((prevData) => ({
                        ...prevData,
                        first_name:response.data.first_name || "",
                        last_name:response.data.last_name || "",
                        email: response.data.email || "",
                        contact_no: response.data.contact_no || "",
                    }));
                }
            })
            .catch((error) => {
              if (error.response && error.response.status === 401) {
                // Handle unauthorized error
                localStorage.clear();
                navigate('/login'); // Redirect to login page
              }

            });
    }
    const loadCategories = async () => {
      // alert('here')
        try {
            let config = {
              headers: { 'Content-Type': 'application/json', 'token': access_token },
            }
            let fields = {
                filters: {
                  // coupon_type: filterType
                },
                pagination: pagination,
                sorting: { field: 'name', type: 'asc' },
            };
            await HTTP.post("/business_cate/list/all",fields)
            .then(async (response) => {
                if (response.status === 200) {
                    setCategoriesList(response.data.contents)
                }
            })
            .catch((error) => {
                // setError(error);
                // setRerenderFlag(true);
                // loadAaMasterData();
                // resetValidationErrors();
            });

            // setIsLoading(false);
        } catch (error) {
            // setError(error);
            // setRerenderFlag(true);
            // setIsLoading(false);
        }
    }
    
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleRadioChange = (e) => {
        setFormData({ ...formData, same_address: e.target.value });
      };

      
      const resetValidationErrors = () => {
        setFirstNameError('');
        setLastNameError('');
        setEmailError('');
        setPhoneNumberError('');
        setUrlError('');
    };
    const validateField = () => {
        resetValidationErrors();
  
        let checked = true;
          if (formData.first_name === '') {
              setFirstNameError('Please enter first name');
              if (checked) {
                  checked = false;
              }
          } else if ((formData.first_name).length < 5) {
              setFirstNameError("Please enter minimum 5 characters");
              if (checked) {
                  checked = false;
              }
          } else if ((formData.first_name).length > 100) {
              setFirstNameError("Max character limit is 100");
              if (checked) {
                  checked = false;
              }
          }

        if (formData.last_name === '') {
            setLastNameError('Please enter last name');
            if (checked) {
                checked = false;
            }
        } else if (formData.last_name.length < 5) {
            setLastNameError("Please enter minimum 5 characters");
            if (checked) {
                checked = false;
            }
        } else if (formData.last_name.length > 100) {
            setLastNameError("Max character limit is 100");
            if (checked) {
                checked = false;
            }
        }
          
          if (formData.email === '') {
              setEmailError('Please enter email address');
              if (checked) {
                  checked = false;
              }
          } 
          else if (!isValidEmail(formData.email)) {
              setEmailError('Invalid email.');
              if (checked) {
                  checked = false;
              }
          }else if ((formData.email).length > 100) {
              setEmailError("Max character limit is 100");
              if (checked) {
                  checked = false;
              }
          }

          if (formData.contact_no === '') {
            setPhoneNumberError('Please enter phone number');
            if (checked) {
                checked = false;
            }
        } else if ((formData.contact_no).length > 100) {
            setPhoneNumberError("Max character limit is 10");
            if (checked) {
                checked = false;
            }
        }
          
          let errorMessage = '';
      
        return checked;
      };

      const handleSubmit = async(e) => {
        e.preventDefault();
        if (validateField()) {
            try {
            const access_token = localStorage.getItem('access_token');
            let config = {
            headers: { "Content-Type": "application/json", token: access_token },
            };

              await HTTP.post(
                "/user/profile/update",
                formData,
                config
              )
                .then(async (response) => {
                  if (response.status === 200) {
                      Swal.fire({
                          title: "Profile updated successfully!",
                        //   text: "Please verify your email before login",
                          icon: "success"
                      });
                    //   setUsermailToVerify(email);
                    //   navigate('/verify');
                  }
                })
                .catch((error) => {
                  if (error.response.status === 406) {
                      resetValidationErrors();
                    //   setPasswordError(error.response.data.detail);
                    Swal.fire({
                        title: 'Error!',
                        text: error.response.data.detail,
                        icon: 'error',
                        confirmButtonText: 'Ok'
                      })
                  }
                  if (error.response.status === 400) {
                      Swal.fire({
                          title: 'Error!',
                          text: 'You are already registered!',
                          icon: 'error',
                          confirmButtonText: 'Ok'
                        })
                  }
                  // setError(error);
                  // setRerenderFlag(true);
                  // loadAaMasterData();
                  // resetValidationErrors();
                });
      
              // setIsLoading(false);
            } catch (error) {
              // setError(error);
              // setRerenderFlag(true);
              // setIsLoading(false);
            }
          }
      };
  return (
    <>
    <form className="space-y-4 mt-8" onSubmit={handleSubmit}>
      <div className="bg-white rounded-lg p-6 border-gray-200 border">
        <h3 className="font-medium text-lg mb-4">Info</h3>
        <div className="grid grid-cols-2 gap-4">

          {/* Owner First Name */}
          <div className="space-y-2">
            <label htmlFor="first_name" className="text-sm font-medium text-gray-500">
              First Name
            </label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              value={formData.first_name}
              onChange={handleChange}
            />
            {firstNameError && <span className="text-sm text-red-500">{firstNameError}</span>}
          </div>

          {/* Owner Last Name */}
          <div className="space-y-2">
            <label htmlFor="last_name" className="text-sm font-medium text-gray-500">
              Last Name
            </label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              value={formData.last_name}
              onChange={handleChange}
            />
            {lastNameError && <span className="text-sm text-red-500">{lastNameError}</span>}
          </div>

          {/* Email */}
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium text-gray-500">
              Email
            </label>
            <input
                disabled="disable"
              type="email"
              id="email"
              name="email"
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              value={formData.email}
              onChange={handleChange}
            />
            {emailError && <span className="text-sm text-red-500">{emailError}</span>}
          </div>
         
          {/* Mobile Number */}
          <div className="space-y-2">
            <label htmlFor="contact_no" className="text-sm font-medium text-gray-500">
              Phone
            </label>
            <input
              type="tel"
              id="contact_no"
              name="contact_no"
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
              value={formData.contact_no}
              onChange={handleChange}
            />
            {phoneNumberError && <span className="text-sm text-red-500">{phoneNumberError}</span>}
          </div>

        </div>
      </div>
      <button
        type="submit"
        className="theme-button text-white px-4 py-2 rounded-md border-gray-200 border"
      >
        Submit
      </button>
    </form>
    <div className="bg-white rounded-lg p-6 mt-8 pb-0 border-gray-200 "> <MemberShipCardStructure  CardWrapper="family-fun-member-card-member shadow-md" heightContainer="min-h-[300px]" isMemberLogin={fullName}/></div>
    </>
  )
}

export default MemberProfile